import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { push, goBack } from 'store/router/actions';

interface UseModalNavigationReturnValues {
  handleCloseModal: VoidFunction;
  handleOpenModal: VoidFunction;
}

export const useCheckoutModalNavigation = (): UseModalNavigationReturnValues => {
  const dispatch = useDispatch();
  const { search, pathname } = useLocation();

  const handleCloseModal = useCallback(() => {
    dispatch(goBack());
  }, [dispatch]);

  const handleOpenModal = useCallback(() => {
    dispatch(push(`${pathname}/terms-and-conditions${search}`));
  }, [dispatch, pathname, search]);

  return { handleCloseModal, handleOpenModal };
};
